import * as React from 'react';
import { FrontLayout } from 'client/ui/layout/FrontLayout';
import { Typography, Divider, Row, Col } from 'antd';
const { Title } = Typography;

import { useState } from 'react';
import { IRequestsQueryDto } from 'common/dto/RequestDto';
import { useApiQuery } from 'client/core/network/hooks/useApiQuery';
import { RequestApi } from 'client/components/schema/requests/RequestApi';
import { AlertPage } from 'client/ui/alert/AlertPage';
import { getNetworkErrorMessage } from 'client/core/network/errors/getNetworkErrorMessage';
import { useBreadcrumbItem } from 'client/core/router/breadcrumb/BreadcrumbContext';
import { RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';
import { RequestListTable } from './RequestListTable';
import { useFrontRequestColumns } from './requestColumns';
export interface RequestsListViewPageProps extends RouteComponentProps {}

/**
 * Elenco delle richieste inviate o in bozza, create dal cittadino loggato
 * correntemente.
 */
export function RequestsListViewPage(props: RequestsListViewPageProps) {
  const [query, setQuery] = useState<IRequestsQueryDto>({
    page: 1,
    pageSize: 10
  });
  const { response, loading, error } = useApiQuery(RequestApi.front.listOwned, {
    data: { query }
  });
  const { t } = useTranslation();

  const columns = useFrontRequestColumns();

  useBreadcrumbItem({
    path: props.location.pathname,
    title: t('procedures.my.breadcrumb', 'Le mie Istanze')
  });

  if (error)
    return (
      <AlertPage
        showIcon
        type="error"
        message={t(
          'procedures.my.list.error-loading',
          'Impossibile caricare l’elenco delle istanze'
        )}
        description={getNetworkErrorMessage(error)}
      />
    );

  return (
    <FrontLayout isUserPage>
      <Title level={3}>{t('procedures.my.list.title', 'Le mie Istanze')}</Title>
      <Divider style={{ marginBottom: 0 }} />
      <RequestListTable
        columns={columns}
        showHeader={false}
        loading={loading}
        data={response?.data}
        onChange={(pagination, filters, sorter) => {
          setQuery({
            ...query,
            page: pagination.current || query.page,
            pageSize: pagination.pageSize || query.pageSize
          });
        }}
        query={query}
      />
    </FrontLayout>
  );
}
